import { CcModal } from "@utp/components-react";
import { Button } from "@utp/react-components-prod";
import ImgClock from "assets/img/clock.svg";

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
}

const ModalTimeFinished = ({ isOpen, onConfirm }: Props) => {
  return (
    <div className="flex justify-center mb-xxlg">
      <CcModal visible={isOpen} hideCloseButton>
        <div className="flex justify-center mb-14">
          <img src={ImgClock} alt="clock" />
        </div>
        <div className="mb-lg">
          <h2 className="font-black text-heading-02 text-color-02 mb-lg text-center">
            El tiempo de tu examen terminó
          </h2>
          <p className="text-center text-color-02">
            Hemos enviado las respuestas que registraste hasta el momento.
          </p>
        </div>
        <div className="flex justify-center gap-lg modal-buttons">
          <Button
            text="Entiendo"
            color="primary"
            className="w-full"
            onClick={onConfirm}
            data-testid="btn-confirm"
          />
        </div>
      </CcModal>
    </div>
  );
};

export default ModalTimeFinished;
